<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Nombre</mat-label>
    <input typeof="text" matInput formControlName="Name">
  </mat-form-field>
  <mat-checkbox class="margin-right-small" formControlName="Deleted">Ver deshabilitados</mat-checkbox>
</form>
